export enum ChatMessageSender {
  user = "user",
  ai = "ai",
}

export interface Call {
  id: string
  agentId?: string
  startedAt: Date | string
}

export enum ChatMessageInputType {
  text = "text",
  voice = "voice",
}

export type TCallDisconnect = { reason: string; description: string }

export enum CallDisconnectType {
  SessionExpired = "Session Expired",
  CreditsExhausted = "Credits Exhausted",
  InActive = "In Active",
  InvalidConfiguration = "Invalid Configuration",
  AgentEnded = "Agent Ended",
  Other = "Other",
}

export const CallDisconnect: Record<CallDisconnectType, TCallDisconnect> = {
  [CallDisconnectType.SessionExpired]: {
    reason: "Session Expired",
    description:
      "Your session has reached its maximum allowed duration. Please start a new call to continue.",
  },
  [CallDisconnectType.CreditsExhausted]: {
    reason: "Credits Exhausted",
    description:
      "The account associated with this agent has inactive subscription or ran out of credits.",
  },
  [CallDisconnectType.InActive]: {
    reason: "Call ended due to inactivity",
    description:
      "It looks like you haven't been active for a while. Click 'Start Conversation' to join a new call.",
  },
  [CallDisconnectType.InvalidConfiguration]: {
    reason: "Invalid Configuration",
    description: "Call ended due to invalid configuration in livekit settings.",
  },
  [CallDisconnectType.AgentEnded]: {
    reason: "Call ended",
    description: "The agent ended the call.",
  },
  [CallDisconnectType.Other]: {
    reason: "Something went wrong",
    description:
      "Please try again later. If the problem persists, contact support.",
  },
}
